import { Close } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import {
  CommonButton,
  CommonOutlinedButton,
} from "../StyledComponents/StyledFields";
import commonStyles from "../../../App.module.scss";
import ButtonLoader from "../ButtonLoader/ButtonLoader";

const ConfirmationDialog = (props: any) => {
  const { open, handleClose, handleProceed, description, title, isBtnLoading } =
    props || {};
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          maxWidth: "600px",
          overflowY: "unset",
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px",
        },
      }}
    >
      <DialogTitle className={commonStyles.dialogTitle}>
        {title}

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 24,
            top: 12,
            color: (theme: any) => theme.palette.grey[500],
          }}
        >
          <Close sx={{ color: "white" }} />
        </IconButton>
      </DialogTitle>
      <Box sx={{ p: "20px" }}>
        <Typography
          id="alert-dialog-slide-description"
          className={commonStyles.dialogContext}
          dangerouslySetInnerHTML={{ __html: description }}
        ></Typography>
        <Box sx={{ mt: "15px", display: "flex", justifyContent: "flex-end" }}>
          <CommonOutlinedButton
            sx={{ mr: "15px" }}
            onClick={() => {
              !isBtnLoading && handleClose();
            }}
          >
            No
          </CommonOutlinedButton>
          <CommonButton onClick={handleProceed}>
            <ButtonLoader isBtnLoading={isBtnLoading} btnText={"Yes"} />
          </CommonButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ConfirmationDialog;
